import * as React from 'react';
import { useCallback, useState, FC } from 'react';

type DnDFilesProps = {
  children: (isDragActive: boolean) => React.ReactNode;
  onFilesAdded: (files: File[]) => void;
};

// eslint-disable-next-line react-refresh/only-export-components
export const makeFiles = (files: FileList) => {
  const filesArray: File[] = [];
  for (const element of files) {
    filesArray.push(element);
  }
  return filesArray;
};

export const DnDFiles: FC<DnDFilesProps> = ({ children, onFilesAdded }) => {
  const [dragActive, setDragActive] = useState(false);
  const handleDrag = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files.length) {
      onFilesAdded(makeFiles(e.dataTransfer.files));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      role='button'
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      {children(dragActive)}
    </div>
  );
};
